import { NavigateFunction } from 'react-router-dom';
import { APP_URLS } from 'constants/urls';
import { InterventionCreatePrefillState } from '../types';

// Shared by every "Create intervention" entry point (Task, Asset, Task
// Reporting, Timeline completions, …) so they all navigate the same way —
// see InterventionCreatePrefillState.
export default function navigateToInterventionCreate(
  navigate: NavigateFunction,
  state?: InterventionCreatePrefillState,
) {
  navigate(APP_URLS.dashboard.interventions.add.path, { state });
}
